class UserForcePasswordResetException {
  constructor(user, password) {
    this.user = user;
    this.password = password;
  }
}

export default UserForcePasswordResetException;
